module.exports = __webpack_public_path__ + "img/datacenter.a7cfaaf4.png";